import { language } from '@tencent/ppd-base-libs';

// 默认语言
const defaultLang = language.getLanguage();

let lang = defaultLang;

/**
 * 获取默认语言
 * @returns
 */
export function getDefaultLang() {
  return defaultLang;
}

/**
 * 获取语言
 * @returns
 */
export function getLang() {
  return lang;
}

/**
 * 设置语言
 * @param inputLang
 */
export function setLang(inputLang: string = defaultLang) {
  lang = inputLang;
}

/**
 * 获取语言包值
 * @param key
 * @param langData 语言包
 * @param data
 * @returns
 */
export function getLangValue(key: string, langData: object, data?: object) {
  let value = langData[key];
  if (data && value) {
    // 说明有要替换的
    value = value.replace(/{{([^}]+)}}/g, (...arg) => {
      const replaceKey = arg[1];
      return data[replaceKey];
    });
    return value;
  }
  if (!value) {
    return key;
  }
  return value;
}
